import { Component, Inject, HostBinding, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAppState, OpenPopin } from '@app/store';
import { Store } from '@ngrx/store';
import { Product, Negotiation } from '@vestiaire/api-sdk-angular';

export interface MmaoPopinComponentData {
  product: Product;
  negotiation: Negotiation | null;
  buyerId: string;
  commentId: string | null;
}

@Component({
  selector: 'vc-mmao-popin',
  templateUrl: './mmao-popin.component.html',
  styleUrls: ['./mmao-popin.component.scss']
})
export class MmaoPopinComponent implements OnInit {
  @HostBinding('class.hasLoader')
  submitting = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: MmaoPopinComponentData, public store: Store<IAppState>) {}

  isSubmitting($event: boolean) {
    this.submitting = $event;
  }

  ngOnInit() {
    this.store.dispatch(new OpenPopin({ name: 'MMAO' }));
  }
}
